import ButtonGlobal from '@shared/Button'
import {  Row, Col, Space } from 'antd'
import React from 'react'

interface CustomResultProps {
  icon: React.ReactNode
  text: string
  info?: React.ReactNode
  buttons: {
    label: string
    type?: 'primary' | 'default'
    onClick?: () => void
  }[]
}

const CustomResult: React.FC<CustomResultProps> = ({
  icon,
  text,
  info,
  buttons,
}) => {
  return (
    <Row
      style={{
        textAlign: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: 20,
      }}
    >
      <Col span={24}>
        <div style={{ fontSize: 40}}>{icon}</div>
        <p style={{ fontSize: 18, fontWeight: 500 }}>{text}</p>
        {info}
      </Col>
      <Col span={24} style={{ marginTop: 16 }}>
        <Space size="middle">
          {buttons.map((btn, index) => (
            <ButtonGlobal
              key={index}
              customType={btn.type}
              onClick={btn.onClick}
            >
              {btn.label}
            </ButtonGlobal>
          ))}
        </Space>
      </Col>
    </Row>
  )
}

export default CustomResult
